import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash', // 去掉#号
  routes: [
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login/Login.vue'], resolve),
      // component: resolve => require(['../views/layout/index.vue'], resolve),
      meta: {title: '登录页面'}
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: resolve => require(['@/views/login/userAgreement.vue'], resolve),
      // component: resolve => require(['../views/layout/index.vue'], resolve),
      meta: {title: '用户协议'}
    },
    {
      path: '/',
      name: 'home',
      component: resolve => require(['../views/layout/index.vue'], resolve),
      redirect: '/login',
      meta: {title: '主页'},
      children: [
        {
          path: '/orderDownload',
          name: 'orderDownload',
          component: resolve => require(['@/views/order/OrderDownloadList.vue'], resolve),
          meta: {title: '按订单下载'}
        },
        {
          path: '/goodsDownload',
          name: 'goodsDownload',
          component: resolve => require(['@/views/goods/GoodsDownloadList.vue'], resolve),
          meta: {title: '按商品下载'}
        },
        {
          path: '/infoDetailDownload',
          name: 'infoDetailDownload',
          component: resolve => require(['@/views/infoDetail/index.vue'], resolve),
          meta: {title: '按资料明细下载'}
        },
        {
          path: '/companyData',
          name: 'companyData',
          component: resolve => require(['@/views/companyData/index.vue'], resolve),
          meta: {title: '医贸首营资料'}
        },
        {
          path: '/manufacturer',
          name: 'manufacturer',
          component: resolve => require(['@/views/manufacturer/index.vue'], resolve),
          meta: {title: '生产企业资料'}
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js